<div class="form-group" [loadingOverlay]="isLoading">
  <div class="d-flex gap-2">
    <div class="w-25 align-self-end">
      <label class="control-label">Customer CMS</label>
      <ng-select [multiple]="false" [closeOnSelect]="true" [clearable]="false"
        placeholder="Not Set" [(ngModel)]="contentManagementSystem"
        (change)="contentManagementSystemChanged()">
        <ng-option *ngFor="let option of contentManagementSystems" [value]="option" class="text-center">
          {{option.Name}}
        </ng-option>
      </ng-select>
    </div>
    <div class="align-self-end">
      <div>
        <button (click)="recheckCustomerCMS()" class="btn btn-warning">
          Check CMS
        </button>
      </div>
    </div>
    <label *ngIf="!contentManagementSystem" class="text-warning align-self-end">Set CMS for this customer to access SEO onsite implementation.</label>
  </div>
</div>
